import logo from './logo.svg';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import './assets/css/style.css';

import React,{useState} from 'react';
import Layout from './layouts/Layout';
import PrivateRoutes from './routes/PrivateRoutes';
import PublicRoutes from './routes/PublicRoutes';
import Login from './containers/Auth/Login';


function App() {
  // const currentUser = JSON.parse(sessionStorage.getItem('userDetail'));
  // const [auth, setAuth] = useState(false);

  // if(currentUser!==null){
  //   setAuth(true)
  // }
  return (
    <div className="App">
      <Layout/>
      {/* {auth ? <PrivateRoutes/> : <PublicRoutes/>} */}
    </div>
  );
}

export default App;
